import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {catchError, Observable, tap, throwError} from 'rxjs';
import {getErrorKeyByCode} from './common/utils';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '@services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private toastr: ToastrService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body.code) {
            this.messageIfError(event.body.code, request);
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const httpStatus = error.status;
        const errorCode = error.error.code;
        if (errorCode) this.messageIfError(errorCode, request);
        else if (httpStatus === 401 || httpStatus === 403) this.authService.logout();
        return throwError(error);
      }))
  }

  private messageIfError(code: number, request: HttpRequest<unknown>) {
    const bypassError: boolean = request.url.includes('user-friend/lookup') && code === 4004;
    const isError: boolean = !(code.toString().startsWith('20'));
    if (isError && !bypassError) {
      const errorKey: string | undefined = getErrorKeyByCode(code);
      if (errorKey) {
        const error = this.translate.instant(errorKey);
        this.toastr.error(error);
      }
    }
  }

}
